import { VisitFlowTypesModel } from '@w3lcome/types';
import RequestCreator from './BaseRequest';

const api = new RequestCreator<VisitFlowTypesModel>('/ipad/visit-flow-types');
export default api;
